"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.cpUtils = void 0;
const tslib_1 = require("tslib");
/* eslint-disable @typescript-eslint/no-namespace */
// NOTE:
// DO NOT EDIT this file in function plugin.
// The source of truth of this file is in packages/vscode-extension/src/debug/depsChecker.
// If you need to edit this file, please edit it in the above folder
// and run the scripts (tools/depsChecker/copyfiles.sh or tools/depsChecker/copyfiles.ps1 according to your OS)
// to copy you changes to function plugin.
const cp = tslib_1.__importStar(require("child_process"));
const os = tslib_1.__importStar(require("os"));
var cpUtils;
(function (cpUtils) {
    async function executeCommand(workingDirectory, logger, options, command, ...args) {
        const result = await tryExecuteCommand(workingDirectory, logger, options, command, ...args);
        if (result.code !== 0) {
            const errorMessage = `Failed to run command: "${command} ${result.formattedArgs}", code: "${result.code}",
                            output: "${result.cmdOutput}", error: "${result.cmdOutputIncludingStderr}"`;
            logger?.debug(errorMessage);
            throw new Error(errorMessage);
        }
        else {
            logger?.debug(`Finished running command: "${command} ${result.formattedArgs}".`);
        }
        return result.cmdOutput;
    }
    cpUtils.executeCommand = executeCommand;
    async function tryExecuteCommand(workingDirectory, logger, additionalOptions, command, ...args) {
        return await new Promise((resolve, reject) => {
            let cmdOutput = "";
            let cmdOutputIncludingStderr = "";
            const formattedArgs = args.join(" ");
            workingDirectory = workingDirectory || os.tmpdir();
            const options = {
                cwd: workingDirectory,
                shell: true,
            };
            Object.assign(options, additionalOptions);
            const childProc = cp.spawn(command, args, options);
            let timer;
            if (options.timeout && options.timeout > 0) {
                // timeout only exists for exec not spawn
                timer = setTimeout(() => {
                    childProc.kill();
                    logger?.debug(`Stop exec due to timeout, command: "${command} ${formattedArgs}", options = '${JSON.stringify(options)}'`);
                    reject(new Error(`Exec command: "${command} ${formattedArgs}" timeout, ${options.timeout} ms`));
                }, options.timeout);
            }
            logger?.debug(`Running command: "${command} ${formattedArgs}", options = '${JSON.stringify(options)}'`);
            childProc.stdout?.on("data", (data) => {
                data = data.toString();
                cmdOutput = cmdOutput.concat(data);
                cmdOutputIncludingStderr = cmdOutputIncludingStderr.concat(data);
            });
            childProc.stderr?.on("data", (data) => {
                data = data.toString();
                cmdOutputIncludingStderr = cmdOutputIncludingStderr.concat(data);
            });
            childProc.on("error", (error) => {
                logger?.debug(`Failed to run command '${command} ${formattedArgs}': cmdOutputIncludingStderr: '${cmdOutputIncludingStderr}', error: ${error}`);
                if (timer) {
                    clearTimeout(timer);
                }
                reject(error);
            });
            childProc.on("close", (code) => {
                logger?.debug(`Command finished with outputs, cmdOutputIncludingStderr: '${cmdOutputIncludingStderr}'`);
                if (timer) {
                    clearTimeout(timer);
                }
                resolve({
                    code,
                    cmdOutput,
                    cmdOutputIncludingStderr,
                    formattedArgs,
                });
            });
        });
    }
    cpUtils.tryExecuteCommand = tryExecuteCommand;
})(cpUtils || (exports.cpUtils = cpUtils = {}));
//# sourceMappingURL=cpUtils.js.map